<template>
  <a class="arrow lightboxNext" :href="next"><i class="fas fa-arrow-right"></i></a>
</template>

<script>
export default {
  name: 'LightboxNext',
  props: ['next']
}
</script>
